import { Persona } from './persona';

export class Parte extends Persona {

  nominativoOriginale: string;
  getAnagraficaTAG(): string {
    return "parte";
  }
}
